import {createSlice} from "@reduxjs/toolkit";

const initialUsersState = {
  listLoading: false,
  totalUsersCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
  partnersOptions: [],
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const partnersSlice = createSlice({
  name: "partners",
  initialState: initialUsersState,
  reducers: {
    partnersFetched: (state, action) => {
      const {totalUsersCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalUsersCount = totalUsersCount;
      state.pageCount = pageCount;
    },
    partnersAppended: (state, action) => {
      const {totalUsersCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalUsersCount = totalUsersCount;
      state.pageCount = pageCount;
    },
    setPartnersOptions: (state, action) => {
      const {options} = action.payload;
      state.partnersOptions = options;
    },
    addPartnersOptions: (state, action) => {
      const data = action.payload;
      state.partnersOptions.push(data);
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
